<ng-container>
    <div class="input-group" (click)="!model.options.readonly && openCalendar()">
        <input
            class="form-control pe-0"
            #dateInput
            [type]="model.options.displayOnlyMonthYear ? 'month' : 'date'"
            [formControl]="dateInputControl"
            paceCoreValidationMessage
            [validation]="dateInputControl"
            [attr.aria-label]="ariaLabel"
            [ngClass]="{ 'invalid-date': !this.model.value.isValid() }"
        />
        <span class="input-group-text" (click)="dateInput.focus()"><fa-icon [icon]="faCalendar"></fa-icon></span>
    </div>
</ng-container>
